import { render, staticRenderFns } from "./StockRevisionWizard.vue?vue&type=template&id=39cbd466"
import script from "./StockRevisionWizard.vue?vue&type=script&lang=js"
export * from "./StockRevisionWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports